import { ThinkingOrb } from 'thinking-orbs'
import { defaultSuggestions } from '../constants/sceneConstants'

export function CommandDock({
  hideSuggs,
  busy,
  agentActivity,
  mode,
  voiceActive,
  inputText,
  onInputChange,
  onSubmit,
  onFocus,
  onBlur,
  onTextMode,
  onVoiceToggle,
  cmdRef,
}) {
  const showOrb = busy || Boolean(agentActivity?.active)

  return (
    <div className="dock">
      <div className={`suggs ${hideSuggs ? 'hide' : ''}`} id="suggs">
        {defaultSuggestions.map((suggestion) => (
          <button key={suggestion} type="button" className="sugg" onClick={() => onSubmit(suggestion)}>
            {suggestion}
          </button>
        ))}
      </div>
      <div className="dock-bar">
        {showOrb ? (
          <div className="dock-busy" aria-hidden={!agentActivity?.active}>
            <ThinkingOrb
              state={agentActivity?.orbState || 'working'}
              size={20}
              theme="dark"
              aria-label={agentActivity?.label || 'Working…'}
            />
          </div>
        ) : null}
        <div className="modes">
          <button type="button" className={mode === 'text' ? 'on' : ''} onClick={onTextMode}>
            <span className="dotm" />TEXT
          </button>
          <button type="button" className={mode === 'voice' ? 'on voice' : 'voice'} onClick={onVoiceToggle}>
            <span className="dotm" />VOICE
          </button>
        </div>
        <label className="cmdwrap" htmlFor="cmd">
          <span className="pmt">&gt;</span>
          <input
            id="cmd"
            ref={cmdRef}
            value={inputText}
            onChange={(e) => onInputChange(e.target.value)}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                onSubmit(inputText)
              }
            }}
            placeholder="describe the ticket - I'll listen, read, and draft it..."
            disabled={busy}
          />
        </label>
        <button type="button" className="send" onClick={() => onSubmit(inputText)} aria-label="Send" disabled={busy}>→</button>
        <button
          type="button"
          className={`mic ${voiceActive ? 'live' : ''}`}
          onClick={onVoiceToggle}
          aria-label="Talk"
          disabled={busy}
        >
          🎙
        </button>
      </div>
    </div>
  )
}
